const scriptsConstants = {
	DYNAMIC_SCRIPT_INSERT: 'dynamic-script-insert',
	DYNAMIC_SCRIPT_INSERT_WIAPI: 'dynamic-script-insert-wiapi'
};

/**
 * This is an object of different methods of adding scripts to the site.
 * Import this file and reference the method you want through the scriptsConstants
 */
const scripts = {
	[scriptsConstants.DYNAMIC_SCRIPT_INSERT]: ({ src }) =>
		new Promise((resolve, reject) => {
			const script = document.createElement('script');
			script.src = src;
			script.addEventListener('load', resolve);
			script.addEventListener('error', (e) => reject(e.error));
			document.head.appendChild(script);
		}),
	[scriptsConstants.DYNAMIC_SCRIPT_INSERT_WIAPI]: async ({ src, win }) => {
		const { APILoader } = win.DDC;
		const API = await APILoader.create('ws-tagging scripts.js');
		return API.loadJS(src);
	}
};

export default scripts;
export { scriptsConstants };
